// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__3F6Xt","NavigationItem":"NavigationItems_NavigationItem__2oc24","active":"NavigationItems_active__29QDI"};